import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import DayOff from "./components/day_off/DayOff";
import Login from "./components/login/login";
import Register from "./components/register/Register";
import ActivateUser from "./components/ActivateUser/ActivateUser";
import Archive from "./components/day_off_archive/archive";
import SubstitutionNew from "./components/Substitution/SubstitutionNew";
import SubstitutionArchive from "./components/Substitution/SubstitutionArchive";
import NewPass from "./components/PassActivate/NewPass";
import PassArchive from "./components/temporaryPasses/PassArchive";
import MenuPage from "./components/AdditionalMobileMenu/MobileAdditionalMenu";
import SignNote from "./components/sign_a_note/SignNote";
import RecoveryPass from "./components/recovery_pass/RecoveryPass";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import { useEffect } from "react";
import GlobalContentContainer from "./components/globalContentContainer/globalContentContainer";
import PoolBooking from "./components/Pool/PoolBooking";
import PoolActive from "./components/Pool/PoolActive";
import ToastNotification from "./components/Notification/ToastNotification";
import PassApplicationForm from "./components/temporaryPasses/PassApplicationForm";
import PassApplicationsList from "./components/temporaryPasses/PassApplicationsList";
import { clearNotification } from "./reduser/notificationSlice";

function App() {
  const username = useSelector((state) => state.user.username);
  const notification = useSelector((state) => state.notification);
  const dispatch = useDispatch();

  useEffect(() => {
    document.title = "Электронная увольнительная записка";
  }, []);

  const handleCloseNotification = () => {
    dispatch(clearNotification());
  };

  return (
    <>
      <Router>
        <Routes>
          {username && (
            <Route
              path="/*"
              element={
                username ? (
                  <GlobalContentContainer />
                ) : (
                  <Navigate to="note/login" />
                )
              }
            >
              <Route path="note/archive" element={<Archive />} />
              <Route path="note/new" element={<DayOff />} />
              <Route path="note/sign_note" element={<SignNote />} />
              <Route path="note/substitution" element={<SubstitutionNew />} />
              <Route path="note/new_pass" element={<NewPass />} />
              <Route path="activate_user" element={<ActivateUser />} />
              <Route path="temporaryPasses" element={<PassApplicationForm />} />
              <Route
                path="temporaryPassesList"
                element={<PassApplicationsList />}
              />
              <Route path="menu" element={<MenuPage />} />
              <Route
                path="note/substitution_archive"
                element={<SubstitutionArchive />}
              />
              <Route path="note/pass_archive" element={<PassArchive />} />
              <Route path="*" element={<Navigate to="note/new" />} />
              <Route path="note/pool_booking" element={<PoolBooking />} />
              <Route path="note/pool_active" element={<PoolActive />} />
            </Route>
          )}
          {/* Неавторизованные маршруты */}
          <Route path="note/login" element={<Login />} />
          <Route path="note/register" element={<Register />} />
          <Route path="note/recovery_pass" element={<RecoveryPass />} />
          <Route path="*" element={<Navigate to="note/login" />} />
        </Routes>
      </Router>

      {/* Глобальное уведомление ВНЕ роутера */}
      {notification.show && (
        <ToastNotification
          show={notification.show}
          message={notification.message}
          onClose={handleCloseNotification}
          type={notification.type}
        />
      )}
    </>
  );
}

export default App;
